import moment from "moment";
import { IHostPlayer } from "services/models/Host";
import { useHostPlayersBirthday } from "services/api/SWRService";
import { PlayerNameCell } from "./PlayerNameCell";
import { GridColDef } from "@mui/x-data-grid-pro";
import { dateCol, tierCol } from "utils/datagrid-utils";
import { GridPaginationProps } from "./helpers";
import { SWRDataGrid } from "./SWRDataGrid";
import { useMobile } from "hooks/Mobile/useMobile";
import { filterPanelSx } from ".";
import { PLAYER_NAME_MIN_WIDTH } from "constants/tables";

type Prop = {
  days?: string;
} & GridPaginationProps;

const columns: GridColDef<IHostPlayer>[] = [
  {
    field: "currentTier",
    headerName: "Tier",
    ...tierCol,
  },
  {
    field: "firstName",
    headerName: "Player",
    flex: 1,
    minWidth: PLAYER_NAME_MIN_WIDTH,
    renderCell: ({ row }) => <PlayerNameCell {...row} />,
  },
  { field: "hostName", headerName: "Host", minWidth: 180 },
  {
    field: "birthdate",
    headerName: "Birthday",
    minWidth: 125,
    ...dateCol,
    valueFormatter: ({ value }) => moment(value).format("MMMM D"),
  },
];

export const UpcomingPlayerBirthdayTable = ({ days, ...paginationProps }: Prop): JSX.Element => {
  const response = useHostPlayersBirthday(days);
  const isMobile = useMobile();

  return (
    <SWRDataGrid
      initialState={{
        columns: {
          columnVisibilityModel: {
            currentTier: false,
          },
        },
      }}
      name="host-players-birthdays"
      columns={columns}
      response={response}
      noRowsMessage="No Birthdays Found"
      slotProps={{
        filterPanel: isMobile ? filterPanelSx : undefined,
      }}
      {...paginationProps}
    />
  );
};
